import defaultView from './default.vue'
import pc from './pc.vue'
export default {
  defaultView,
  pc
}
